import { GRID_DATA_LIMIT } from '../../../constants';
import { Dataset, JSONObject } from '../../../types/types';
import { getItemsParamArray } from '../../../utils/apiRequests/getItemsParamArray';
import { getSortParamArray } from '../../../utils/apiRequests/getSortParamArray';
import { DatasetDataApiRequestData } from '../../types/types';
import { normalizeCachedQueryId } from '../../../utils/dataset/normalizeCachedQueryId';
import { debugLogger } from '../../../debug/DebugLogger';

const log = debugLogger.scope('datasetControl');

export const getDatasetDataApiRequestData = (
  dataset: Dataset,
  activeSorting: any[],
  token: string | null,
  offset: number,
  filters?: Record<string, any>,
  limit?: number | null,
  cachedQueryId?: string | null,
  itemsOverride?: string[],
  omitPagination?: boolean,
  datasetControl?: JSONObject
): DatasetDataApiRequestData => {
  const normalizedCachedQueryId = normalizeCachedQueryId(cachedQueryId);
  if (datasetControl) {
    /** @debugFeature datasetControl Logs dataset control data attached to a dataset data request — backend apiMethod templates consume it. */
    log('dataset control data attached to request', () => ({
      datasetId: dataset.datasetId,
      datasetControl,
    }));
  }

  return {
    datasetId: dataset.datasetId || '',
    sessionId: token || '',
    ...(normalizedCachedQueryId
      ? { cachedQueryId: normalizedCachedQueryId }
      : {}),
    // omitPagination reproduces the legacy export builder's single un-paginated request
    ...(omitPagination
      ? {}
      : {
          offset,
          limit: limit === null ? undefined : limit || GRID_DATA_LIMIT,
        }),
    items: itemsOverride ?? getItemsParamArray(dataset),
    sort: getSortParamArray(activeSorting),
    filters: filters && Object.keys(filters).length > 0 ? filters : undefined,
    ...(datasetControl ? { datasetControl } : {}),
  };
};
